import Cookies from 'js-cookie'
import Qs from 'qs'
export default {
  localStorage: window.localStorage,
  sessionStorage: window.sessionStorage,
  getType(object) {
    return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1]
  },
  setTitle(title) {
    let t = document.querySelector('title')
    t.textContent = title
  },
  getSessionStorage(key) {
    return this.sessionStorage.getItem(key)
  },
  setSessionStorage(key, value) {
    this.sessionStorage.setItem(key, value)
  },
  removeSessionStorage(key) {
    this.sessionStorage.removeItem(key)
  },
  getLocal(key) {
    return this.localStorage.getItem(key)
  },
  // 存储数据到localstorage
  setLocal(key, value) {
    this.localStorage.setItem(key, value)
  },
  // 根据key移除localstorage存储数据
  removeLocalStorage(key) {
    this.localStorage.removeItem(key)
    this.removeSessionStorage(key)
    Cookies.remove(key)
  },
  getUrlParam(url, name, type) {
    if (type == 1) {
      url = url.split('/');
      return url[url.length - 1]
    } else {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    }
  },
  // 判断对象是否为空
  isEmptyObject(obj) {
    if (!obj) return true
    for (let i in obj) {
      return false
    }
    return true
  },
  // 时间戳转换
  timefn(timestamp, type) {
    var date
    if (!isNaN(timestamp)) {
      timestamp = timestamp
    } else {
      if (timestamp && timestamp.length > 0) {
        timestamp = timestamp.indexOf('-') != -1 || timestamp.indexOf('/') != -1 ? (Number(new Date(timestamp.replace(/-/g, '/')).getTime())) : new Date(timestamp).getTime()
      }
    }
    date = timestamp > 9999999999 ? (new Date(parseInt(timestamp))) : (new Date(parseInt(timestamp) * 1000))
    var Y = date.getFullYear() + '/'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
    var D = date.getDate() > 9 ? date.getDate() + ' ' : '0' + date.getDate() + ' '
    var h = date.getHours() > 9 ? date.getHours() + ':' : '0' + date.getHours() + ':'
    var m = date.getMinutes() > 9 ? date.getMinutes() + ':' : '0' + date.getMinutes() + ':'
    var s = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
    if (type == 1) {
      return Y + M + D
    } else if (type == 2) {
      return M + D
    } else {
      return Y + M + D + h + m + s
    }
  },
  getWeek(timestamp) {
    var str = "";
    if (!isNaN(timestamp)) {
      timestamp = timestamp
    } else {
      if (timestamp && timestamp.length > 0) {
        timestamp = timestamp.indexOf('-') != -1 || timestamp.indexOf('/') != -1 ? (Number(new Date(timestamp.replace(/-/g, '/')).getTime())) : new Date(timestamp).getTime()
      }
    }
    var week = (timestamp > 9999999999 ? (new Date(parseInt(timestamp))) : (new Date(parseInt(timestamp) * 1000))).getDay();
    if (week == 0) {
      str = "星期日";
    } else if (week == 1) {
      str = "星期一";
    } else if (week == 2) {
      str = "星期二";
    } else if (week == 3) {
      str = "星期三";
    } else if (week == 4) {
      str = "星期四";
    } else if (week == 5) {
      str = "星期五";
    } else if (week == 6) {
      str = "星期六";
    }
    return str
  },
  // 根据数组某个属性排序
  sortByKey(array, key) {
    return array.sort(function(a, b) {
      return (parseInt(a[key]) - parseInt(b[key]))
    })
  },
  // 去重
  deduplication(arr, key, key1) {
    var result = []
    for (var t of arr) {
      if (result.find(c => c[key] === t[key] && c[key1] === t[key1])) {
        continue
      }
      result.push(t)
    }
    return result
  },
  setOtherInfo(info, data) {
    this.setLocal(info, data)
    this.setSessionStorage(info, data)
  },
  getOtherInfo(info) {
    return this.getLocal(info) || this.getSessionStorage(info) || 'null'
  },
  // 根据度数获得风向
  getWindDirection(degree) {
    if (degree >= 22.5 && degree <= 67.5) {
      return '(东北风)'
    } else if (degree >= 67.5 && degree <= 112.5) {
      return '(东风)'
    } else if (degree >= 112.5 && degree <= 157.5) {
      return '(东南风)'
    } else if (degree >= 157.5 && degree <= 202.5) {
      return '(南风)'
    } else if (degree >= 202.5 && degree <= 247.5) {
      return '(西南风)'
    } else if (degree >= 247.5 && degree <= 292.5) {
      return '(西风)'
    } else if (degree >=  292.5 && degree <= 337.5) {
      return '(西北风)'
    }  else {
      return '(北风)'
    }
  },
  getCodeTip(code) {
    const codeAll = {
      '10001': '服务器错误，请稍后重试！',
      '10002': '抱歉，您没有此功能权限！',
      '10003': '缺少必要的信息，请验证后重试！',
      '10004': '服务器繁忙，请稍后重试！',
      '10005': '登录信息已过期，请您退出并重新登录！', // 需要退出
      '10006': '信息错误，请您退出并重新登录', // 需要退出
      '10007': '账号已存在！',
      '10008': '登录滑动认证失败，请重试！',
      '10009': '账号或者密码错误，请检查后重试！',
      '10010': '用户信息不存在或已删除！', // 需要退出
      '10011': '抱歉，您没有权限删除自身账号！',
      '10012': '获取临时认证信息错误！',
      '10013': '数据大屏不存在或已被删除！',
      '10014': '天气信息获取失败，请您稍后重试！',
      '10015': '信息获取失败，请您稍后重试！',
      '10016': '模板不存在，或已失效！',
      '10017': '图片地址已失效，请您重新上传！',
      '10018': '缺少必要的参数，请验证后重试！',
      '10019': '缺少必要的参数，您暂无法订阅，请您稍后重试！',
      '10020': '添加数据大屏失败，请您稍后重试！',
      '10021': '数据源使用中，无法删除！',
      '10022': '信息已失效，请稍后重试！',
      '10023': '获取微信OpenId失败，请您稍后重试！',
      '10024': '该模板不在您的组织下，您无法访问！',
      '11104': 'AccessId 或者 AccessKey 错误，请检查后重试！'
    };
    return (codeAll[code] ? codeAll[code] : false)
  },
}
